"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
class Account {
    constructor(name) {
        if (name.startsWith("accounts/")) {
            this._name = name;
        }
        else {
            this._name = "accounts/" + name;
        }
    }
    static fromJson(value) {
        return new Account(value._key);
    }
    get name() {
        return this._name.replace("accounts/", "");
    }
    toString() {
        return this.name;
    }
    toJson() {
        return { _key: this._name };
    }
}
exports.Account = Account;
//# sourceMappingURL=Account.js.map